<template>
  <span :class="classes">
    <!-- @slot The hint text  -->
    <slot />
  </span>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import { InputState, VueClass } from 'komodo2/types'

export default defineComponent({
  name: 'KomodoInputHint',
  props: {
  /**
   * Indicates what state the hint should be rendered in
   */
    state: {
      type: String as PropType<InputState>,
      required: false,
      default: InputState.Default
    }
  },
  setup (props) {
    const classes = computed((): VueClass => {
      return {
        'k2-input-hint': true,
        'k2-input-hint-error': props.state === InputState.Error
      }
    })

    return {
      classes
    }
  }
})
</script>

<style lang="scss" scoped>
.k2-input-hint {
  @include k2-font-text-caption;
  @include k2-color-neutrals-secondary-text;

  margin-left: 12px;

  &.k2-input-hint-error {
    @include k2-color-error-darken-1;
  }

}
</style>
